import axios from "axios";

export const createPerson = async (username, personVOToCreate) => {
    try {
        const {data} = await axios.post("/api/person/create", {username, personVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllPersons = async (username) => {
    try {
        const {data} = await axios.get("/api/person/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
